// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.veworld",
    name: "VeWorld Mobile",
    homepage: "https://veworld.com",
    image_id: "afa5084b-02da-4dd4-418b-9f6410e34e00",
    app: {
        browser: null,
        ios: "https://www.veworld.com/",
        android: "https://www.veworld.com/",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "veworld://org.vechain.veworld.app/",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map